import * as Type from './actionsTypes';

const loadMunicipioUsuario = (callback) => ({
  type: Type.CALENDARIO_FERIADO_LOAD_MUNICIPIO_USUARIO,
  callback,
});

const loadCalendarioPublico = (codigosIbge, ano, callback) => ({
  type: Type.CALENDARIO_FERIADO_LOAD_PUBLICO,
  codigosIbge: Array.isArray(codigosIbge) ? codigosIbge : [codigosIbge],
  ano,
  callback,
});

const loadCalendarioAdminCalendar = (filter, callback) => ({
  type: Type.CALENDARIO_FERIADO_LOAD_ADMIN_CALENDAR,
  filter,
  callback,
});

const loadMunicipiosUsuariosAtivos = (callback) => ({
  type: Type.CALENDARIO_FERIADO_LOAD_MUNICIPIOS_USUARIOS_ATIVOS,
  callback,
});

const criarFeriado = (data, callback) => ({
  type: Type.CALENDARIO_FERIADO_CRIAR,
  data,
  callback,
});

const atualizarFeriado = (data, callback) => ({
  type: Type.CALENDARIO_FERIADO_ATUALIZAR,
  data,
  callback,
});

const invalidarFeriado = (id, motivo, callback) => ({
  type: Type.CALENDARIO_FERIADO_INVALIDAR,
  id,
  motivo,
  callback,
});

const revalidarFeriado = (id, callback) => ({
  type: Type.CALENDARIO_FERIADO_REVALIDAR,
  id,
  callback,
});

const cleanCalendarioFeriado = () => ({ type: Type.CALENDARIO_FERIADO_CLEAN });

export {
  loadMunicipioUsuario,
  loadCalendarioPublico,
  loadCalendarioAdminCalendar,
  loadMunicipiosUsuariosAtivos,
  criarFeriado,
  atualizarFeriado,
  invalidarFeriado,
  revalidarFeriado,
  cleanCalendarioFeriado,
};
